import { AiConfigInterface } from '@/components/AiComponent/Interface/AiConfigInterface';
import { RobotInterface } from '@/components/AiComponent/Interface/RobotInterface';
import ActionRender from '@/components/AiComponent/Render/ActionRender';
import BubbleListRender from '@/components/AiComponent/Render/BubbleListRender';
import SenderRender from '@/components/AiComponent/Render/SenderRender';

export const RobotConfig = (robot: RobotInterface) => {
  let robotConfig: AiConfigInterface = {};
  if (robot?.code === 'BOM_DRAW_AI_ROBOT') {
    robotConfig.actionRender = () => <ActionRender robot={robot} />;
    robotConfig.senderRender = () => <SenderRender robot={robot} />;
    robotConfig.bubbleListRender = () => <BubbleListRender robot={robot} />;
  }
  console.log(robotConfig, 'robotConfig');
  return robotConfig;
};
